// extracted by mini-css-extract-plugin
module.exports = {"matches":"MatchCardsList_matches__8_UwB","link":"MatchCardsList_link__geDx5"};